export default __webpack_public_path__ + "static/media/transport-1.e0affd1f.jpg";